

import { Modal, ModalProps } from "antd"
import classNames from "classnames"
import { useState } from "react"

interface EditModalProps extends ModalProps {
  trigger: any
  className?: string
  onSuccess?: () => void
  children: any
}

export function EditModal(props: EditModalProps) {
  const {trigger, className, onCancel, onOk, title, children, ...reset} = props
  const [show, setShow] = useState(false)

  const handleCancel = (e) => {
    onCancel?.(e)
    setShow(false)
  }

  const handleSave = (e) => {
    onOk?.(e)
    setShow(false)
  }

  return <>
    <div onClick={() => setShow(true)} className={classNames(className)} style={{cursor: 'pointer'}}>
      {trigger}
    </div>
    {show && <Modal title={title} open={true} {...reset} onOk={handleSave} onCancel={handleCancel} maskClosable={false}>
      {children}
    </Modal>}
  </>
}